import { useMe } from "@/api/me";
import Title from "@/components/layout/title";
import PatientsTable from "@/components/table/patients/patients-table";
import Loader from "@/components/ui/loader";

const DashboardPage = () => {
  const { data: me, isLoading } = useMe();

  if (isLoading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  if (!me) {
    return <div>Pas d'utilisateur connecté</div>;
  }

  return (
    <div className="flex flex-col w-full gap-6 px-[5%] pb-8">
      <Title
        title={`Bonjour ${me?.firstName},`}
        subTitle=""
        className="flex flex-col gap-4"
      />
      <div className="flex flex-col gap-6">
        <PatientsTable />
      </div>
    </div>
  );
};

export default DashboardPage;
